import { Component, OnInit } from '@angular/core';
import { ShowService } from '../../services/show.service';
import { Show } from '../../models/show.model';
import { PlayerService } from '../../services/player.service';

@Component({
  selector: 'app-player',
  templateUrl: './player.component.html',
  styleUrls: ['./player.component.scss']
})
export class PlayerComponent implements OnInit {
   public audio: HTMLAudioElement;
   public show: Show;
   public showDesc = false;

  constructor(private showService: ShowService, private playerService: PlayerService) {
     this.audio = new Audio();
     this.audio.src = 'http://servidor.ilive.com.ar:8654/;';
     this.audio.load();
  }

  ngOnInit() {
     this.showService.getCurrentShow().subscribe(show => {
        this.show = show;
     });
     this.playerService.playerState$.subscribe(state => {
        if (state) {
           this.play();
        } else {
           this.pause();
        }
     });
     this.playerService.setPlayerState(false);
  }

  play() {
     this.audio.play();
  }

  pause() {
     this.audio.pause();
  }

  toggleDescription() {
     this.showDesc = !this.showDesc;
  }

}
